import { numberToHex } from "viem";
import config from "../config/config";

type RequestProvider = {
  request: (...args: any[]) => Promise<any>;
};

export const switchNetwork = async (provider: RequestProvider) => {
  const chainId = config.chainId;
  try {
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: numberToHex(chainId) }],
    });

    return true;
  } catch (switchError: any) {
    if (switchError.code === 4902 || switchError.code === -32603) {
      try {
        await addNetwork(provider);
        return true;
      } catch (error) {
        alert(error);
        return false;
      }
    }
    return false;
  }
};

export const addNetwork = async (provider: RequestProvider) => {
  await provider.request({
    method: "wallet_addEthereumChain",
    params: [
      {
        chainId: numberToHex(config.chainId),
        chainName: config.chainName,
        nativeCurrency: {
          name: "PulseChain",
          symbol: config.chainSymbol,
          decimals: 18,
        },
        rpcUrls: [config.providerList[0]],
        blockExplorerUrls: [config.explorerUrl],
      },
    ],
  });
};
